<!-- 邀请注册并审核  -->
<template>
  <div class='inviteAudit'>
    <v-header :headTitle='headTitle' :isBack='true' :pageName="pageName"></v-header>
    <div class="container">
      <div class="item" >
        <div class="item-title df-item-center">
          <span class='df-center'>1</span>
          <h3>邀请监测小组成员注册</h3>
        </div>
        <div class="item-content">
          <p>已下载安装并注册的，可忽略</p>
          <div class="btn df-center" @click='handleInvite'> 邀请注册并安装APP </div>
        </div>
      </div>
      <div class="item" >
        <div class="item-title df-item-center">
          <span class='df-center'>2</span>
          <h3>审核注册人员信息</h3>
        </div>
        <div class="item-content">
          <p>审核通过后才能进行相关操作</p>
          <div class="btn df-center" @click='handleGoAudit'> 待审核（{{notAuditNumber}}） </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import header from '../../components/header/header'
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
        headTitle:'邀请注册并审核',
        pageName:'',
        notAuditNumber:0
      }
    },
    components: {
      'v-header': header
    },
    created() {
      this.initNotAudit()
    },
    mounted() {
      let _this = this
      window.refreshInviteAudit = function(){
        _this.initNotAudit()
      }
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
        baseUrl: (state) => state._base
      })
    },
    methods: {
      initNotAudit(){
        let params = {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          data: {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            isAuth:'2,6'
          }
        };
        this.$http.getUserCountByAuthorState(params).then((res) => {
          if (res.code === 0) {
            this.notAuditNumber = res.data
          } else {
            this.$toast(res.msg);
          }
        });
      },
      handleInvite(){
        let url = `${this.baseUrl}/gk2018/?entryId=Invite&appCode=${this._userInfo.data.appCode}&userId=${this._userInfo.data.userId}`
        let content ='我们在用感控工作间进行医院感控管理，快来加入吧！'
        let title =this._userInfo.data.cnName+'邀请您加入'+this._userInfo.data.comName+'感控工作间'
        try {
          uni.postMessage({
            data: {
              action: 'showShareView',
              data: {
                shareUrl: url,
                shareTitle: title,
                shareContent: content,
              }
            }
          });
          window.webkit.messageHandlers.showShareView.postMessage({
            shareUrl: url,
            shareTitle: title,
            shareContent: content,
          })
        } catch (err) {
          window.gk.showShareView(url, title, content)
        }
      },
      handleGoAudit(){
        try {
          uni.postMessage({
            data: {
              action: 'startType',
              data: 'reviewed'
            }
          });
          window.webkit.messageHandlers.startType.postMessage('reviewed');
        } catch (err) {
          window.gk.startType('reviewed');
        }
      }
    },
  }
</script>
<style lang='scss' scoped>
  .inviteAudit {
    .container {
      padding: 17px 12px;
      .item {
        .item-title {
          font-size: 17px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          span {
            width: 22px;
            height: 22px;
            background: #26b4ff;
            border-radius: 50%;
            color: #fff;
          }
          h3 {
            margin-left: 13px;
          }
        }
        .item-content {
          margin-left: 11px;
          padding: 0px 0px 15px 20px;
          border-left: 1px solid #eee;
          background-color: #fff;
          p{
            margin: 10px 0px 15px;
            font-size: 15px;
            color: #666666;
          }
          .btn{
            width: 235px;
            height: 44px;
            background: #1c91ff;
            border-radius: 22px;
            font-size: 18px;
            color: #fff;
          }
        }
      }
    }
  }
</style>